import React from "react"

export default function SatispayForm() {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div>
      <p style={{ fontSize: 12 }}>
        {I18n.t("cart_summary.satispay.description")}
      </p>
    </div>
  )
}
